import QuickInfo from './QuickInfo';
export default QuickInfo;